// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerChoices_root__1ybna"};